// Accenti illustrati vettoriali, delicati e riutilizzabili per le atmosfere.
// Stile pittorico sobrio: spazio libero, nessuna icona generica, nessuna vegetazione fitta.

export function DawnAccent() {
  return (
    <svg viewBox="0 0 400 300" preserveAspectRatio="xMidYMax slice" className="absolute inset-0 w-full h-full" aria-hidden="true">
      <defs>
        <linearGradient id="dawnHorizon" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0%" stopColor="#E7C98A" stopOpacity="0.5" />
          <stop offset="100%" stopColor="#E7C98A" stopOpacity="0" />
        </linearGradient>
      </defs>
      <rect x="0" y="232" width="400" height="68" fill="url(#dawnHorizon)" />
      <path d="M0 256 Q200 240 400 256" fill="none" stroke="#C9A24B" strokeOpacity="0.3" strokeWidth="1.4" />
      <path d="M0 274 Q200 262 400 274" fill="none" stroke="#C9A24B" strokeOpacity="0.2" strokeWidth="1.1" />
    </svg>
  );
}

export function StarsAccent() {
  const pts = [
    [58, 54, 2.4], [96, 92, 1.5], [330, 60, 2.1], [300, 110, 1.4],
    [360, 140, 1.7], [70, 150, 1.3], [250, 44, 1.6],
  ];
  return (
    <svg viewBox="0 0 400 300" className="absolute inset-0 w-full h-full" aria-hidden="true">
      {pts.map(([x, y, r], i) => (
        <circle key={i} cx={x} cy={y} r={r} fill="#D9B45F" fillOpacity={0.55} />
      ))}
    </svg>
  );
}

export function WaterAccent() {
  return (
    <svg viewBox="0 0 400 300" preserveAspectRatio="xMidYMax slice" className="absolute inset-0 w-full h-full" aria-hidden="true">
      <g stroke="#9DB6AE" strokeLinecap="round" fill="none">
        <path d="M40 262 h110" strokeOpacity="0.42" strokeWidth="2" />
        <path d="M210 262 h150" strokeOpacity="0.34" strokeWidth="2" />
        <path d="M70 278 h90" strokeOpacity="0.3" strokeWidth="1.6" />
        <path d="M200 278 h120" strokeOpacity="0.24" strokeWidth="1.6" />
        <path d="M50 292 h70" strokeOpacity="0.22" strokeWidth="1.3" />
        <path d="M250 292 h90" strokeOpacity="0.2" strokeWidth="1.3" />
      </g>
      <g stroke="#C9A24B" strokeLinecap="round" fill="none" strokeOpacity="0.18">
        <path d="M150 270 h40" strokeWidth="1.2" />
        <path d="M300 285 h30" strokeWidth="1.1" />
      </g>
    </svg>
  );
}

export function FlowerAccent() {
  // Un fiore che si apre, delicato, nell'angolo
  return (
    <svg viewBox="0 0 400 300" className="absolute inset-0 w-full h-full" aria-hidden="true">
      <g transform="translate(330 232)" opacity="0.85">
        <g fill="none" stroke="#B79BD0" strokeWidth="1.6" strokeOpacity="0.7" strokeLinecap="round">
          <path d="M0 0 C -6 -22 -2 -40 0 -46 C 2 -40 6 -22 0 0 Z" />
          <path d="M0 0 C 14 -16 30 -20 38 -20 C 30 -12 18 -2 0 0 Z" />
          <path d="M0 0 C -14 -16 -30 -20 -38 -20 C -30 -12 -18 -2 0 0 Z" />
          <path d="M0 0 C 10 -6 22 -2 28 4 C 18 6 8 6 0 0 Z" />
          <path d="M0 0 C -10 -6 -22 -2 -28 4 C -18 6 -8 6 0 0 Z" />
        </g>
        <circle cx="0" cy="-6" r="3.2" fill="#D9B45F" fillOpacity="0.85" />
        <path d="M0 0 C 2 20 1 38 -1 52" fill="none" stroke="#9DB6AE" strokeOpacity="0.5" strokeWidth="1.4" />
      </g>
    </svg>
  );
}

export function LeavesAccent() {
  // Poche foglie leggere, sull'altro lato
  return (
    <svg viewBox="0 0 400 300" className="absolute inset-0 w-full h-full" aria-hidden="true">
      <g transform="translate(58 250)" opacity="0.8" fill="none" stroke="#A7BE9E" strokeWidth="1.5" strokeOpacity="0.75" strokeLinecap="round">
        <path d="M0 0 C 8 -18 8 -34 4 -46" />
        <path d="M4 -16 C -8 -22 -16 -24 -22 -22 C -14 -14 -6 -12 4 -16 Z" />
        <path d="M3 -30 C 13 -34 21 -36 27 -34 C 19 -26 11 -26 3 -30 Z" />
      </g>
    </svg>
  );
}

export const ACCENTS = {
  dawn: DawnAccent,
  stars: StarsAccent,
  water: WaterAccent,
  flower: FlowerAccent,
  leaves: LeavesAccent,
};
